import { toast } from '@buffer-mono/popcorn'

import { commentDetailsRoute } from '~publish/legacy/routes'

/**
 * The absolute, shareable URL for a comment. Always uses the all-channels
 * Community path so the link works for any recipient regardless of which
 * Community view they were in when it was copied.
 */
const getCommentShareLink = (commentId: string): string =>
  `${window.location.origin}${commentDetailsRoute.getRoute({ commentId })}`

/**
 * Copies the shareable link for a comment to the clipboard and toasts the
 * outcome. Returns whether the copy succeeded.
 */
export const copyCommentUrlToClipboard = async (
  url: string,
): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(url)
    toast.success('Comment link copied')
    return true
  } catch {
    toast.error('Unable to copy link')
    return false
  }
}

export const copyCommentLinkToClipboard = (
  commentId: string,
): Promise<boolean> => copyCommentUrlToClipboard(getCommentShareLink(commentId))
